import { FC } from 'react';
import {
	Modal,
	ModalBody,
	ModalContent,
	ModalOverlay,
	ModalHeader,
	ModalFooter,
	Text,
	Button,
	VStack,
	HStack,
	Icon,
} from '@chakra-ui/react';
import { IoCardOutline } from 'react-icons/io5';

interface InsufficientCreditsModalProps {
	isOpen: boolean;
	onClose: () => void;
	onContinue: () => void;
	amountRequired?: number;
}

const InsufficientCreditsModal: FC<InsufficientCreditsModalProps> = ({
	isOpen,
	onClose,
	onContinue,
	amountRequired = 0,
}) => {
	const formattedAmount = amountRequired.toFixed(2);

	return (
		<Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
			<ModalOverlay zIndex={1800} />
			<ModalContent
				containerProps={{
					zIndex: 1900,
				}}
			>
				<ModalHeader textAlign="center" pb={2}>
					<VStack spacing={3}>
						<Icon as={IoCardOutline as any} w={12} h={12} color="orange.500" />
						<Text fontSize="xl" fontWeight="semibold">
							Insufficient credits for Google Ads
						</Text>
					</VStack>
				</ModalHeader>

				<ModalBody textAlign="center" py={4}>
					<VStack spacing={4}>
						<Text fontSize="sm" color="gray.600">
							{amountRequired > 0
								? `We pay your GoogleAds directly to Google, please add $${formattedAmount} in credits to your account to publish them. Once you pay for your Google Ads, we will continue with the rest of the channels.`
								: 'We pay your GoogleAds directly to Google, please add more credits to your account to publish them. Once you pay for your Google Ads, we will continue with the rest of the channels.'}
						</Text>
					</VStack>
				</ModalBody>

				<ModalFooter justifyContent="center" pt={6}>
					<HStack spacing={4}>
						<Button onClick={onClose}>Cancel</Button>
						<Button
							variant="orangeSolid"
							onClick={onContinue}
							leftIcon={<Icon as={IoCardOutline as any} />}
						>
							Add Credits
						</Button>
					</HStack>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default InsufficientCreditsModal;
